import { render, staticRenderFns } from "./regResourceMenu.vue?vue&type=template&id=63b097d2"
import script from "./regResourceMenu.vue?vue&type=script&lang=js"
export * from "./regResourceMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports